import {t} from "@lingui/core/macro";

import {View} from "@khanacademy/wonder-blocks-core";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {LabelSmall} from "@khanacademy/wonder-blocks-typography";

/**
 * A component that displays a heading for the table view of Khanmigo chat history.
 * The heading informs users that Khanmigo chats are kept for 60 days and then may be deleted.
 * The component is aligned to the end (right in LTR layouts) and has top margin.
 *
 * @returns A React node containing the heading text wrapped in a styled View
 */
export function TableViewHeading(): React.ReactNode {
    return (
        <View style={{marginBlockStart: spacing.large_24, alignItems: "end"}}>
            <LabelSmall>{t`Khanmigo chats are kept for 60 days, then may be deleted`}</LabelSmall>
        </View>
    );
}
